import config from '../../../../../config';
import {authFetch, checkStatus} from '../../../../utils/http';
import {convertProjectInvitationsFromAPI} from '../../helper';

export const INVITATION_API = `${config.enrollmentApi}/api/v1/invitations`;

function inviteOrganisations(organisationSourceId, data) {
  return authFetch(`${INVITATION_API}/${organisationSourceId}/projects`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(checkStatus);
}

function cancelPendingInvitation(invitationId) {
  return authFetch(`${INVITATION_API}/${invitationId}`, {
    method: 'DELETE'
  })
    .then(checkStatus);
}

function resendInvitation(invitationId, reason) {
  return authFetch(`${INVITATION_API}/${invitationId}/resend`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(reason)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => convertProjectInvitationsFromAPI([response]));
}

function getByProjectId(projectId) {
  return authFetch(`${INVITATION_API}/projects/${projectId}`)
    .then(checkStatus)
    .then(response => response.json())
    .then(response => convertProjectInvitationsFromAPI(response));
}

/*
{
  "status": ["PENDING", "ACCEPTED"],
  "organisationId": 1,
  "email": "john.doe@alg.fr",
  "projectId": 2,
  "country": "FRANCE",
  "registrationNumber": "123456789",
  "vatIdentificationNumber": "FR123456789"
}
*/
function searchBy(data) {
  return authFetch(`${INVITATION_API}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => convertProjectInvitationsFromAPI(response));
}

export default {
  inviteOrganisations,
  cancelPendingInvitation,
  resendInvitation,
  getByProjectId,
  searchBy
};
